<template>
  <div id="app">
    <div class="page">
      <app-head v-if="header_show"></app-head>
<!--      <app-nav></app-nav>-->
      <!--keep-alive 切换路不会触发mounted-->
      <keep-alive><router-view v-on:header="header" v-on:footer="footer"></router-view></keep-alive>
      <app-foot v-if="footer_show"></app-foot>
    </div>
  </div>
</template>

<script>
import AppHead from '@/components/public/Head'
// import AppNav from '@/components/public/Nav'
import AppFoot from '@/components/public/Foot'
import global from '@/components/public/Common';

export default {
  name: 'app',
  data(){
    return {
      header_show:true,//控制是否显示头部
      footer_show:true
    }
  },
  components: {
    'app-head': AppHead,
    // 'app-nav': AppNav,
    'app-foot': AppFoot
  },
  created: function () {
    let _this = this;
    if(global.orgid=='ins_005'){
      //北部湾不显示头尾部
      _this.header_show = false;//控制不显示头部（北部湾）
      _this.footer_show = false;//控制不显示尾部（北部湾）
    }
  },
  methods:{
    //是否显示头部
    header:function (bool) {
      this.header_show = bool;
    },
    //是否显示底部
    footer:function (bool) {
      this.footer_show = bool;
    }
  }
}
</script>

<style scoped>
 @import "style/common.css";
</style>
<style>
#app{
  overflow: hidden;
}
.page{
  position: relative;
  z-index: 99;
  transition: all 0.5s;
}
.toggle{
  transform: translateX(-120px);
}
  body{
    margin:0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue